"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
function SimpleAjaxChat() {
  const [chatHtml, setChatHtml] = useState('[better_messages_chat_room id="5758"]');
  useEffect(() => {
    const pollingInterval = setInterval(() => {
      setChatHtml('[better_messages_chat_room id="5758"]');
    }, 5000);
    const handleChatUpdate = () => {
      setChatHtml('[better_messages_chat_room id="5758"]');
    };
    window.addEventListener('sac_after_insert', handleChatUpdate);
    return () => {
      clearInterval(pollingInterval);
      window.removeEventListener('sac_after_insert', handleChatUpdate);
    };
  }, []);
  return <div className="w-full flex-1" dangerouslySetInnerHTML={{
    __html: chatHtml
  }} />;
}
export default function WPStreamPlayer() {
  const [isLive, setIsLive] = useState(false);
  useEffect(() => {
    const checkLiveStatus = async () => {
      try {
        const response = await fetch('https://rackemjoelivestream.net/wp-json/wpstream/v1/get_status?id=65');
        const data = await response.json();
        setIsLive(!!data.is_live);
      } catch (error) {
        setIsLive(false);
      }
    };
    checkLiveStatus();
    const interval = setInterval(checkLiveStatus, 30000);
    return () => clearInterval(interval);
  }, []);
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  return <section className="relative bg-background py-16 lg:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={containerRef} className={`transition-all duration-700 ease-out ${containerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
            {}
            <div className="bg-surface rounded-lg shadow-medium p-6 lg:p-8">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground">
                  Live Stream
                </h2>
                <div className="flex items-center gap-2 px-3 py-1 bg-primary/20 border border-primary rounded-full">
                  <span className="relative flex size-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary opacity-75"></span>
                    <span className="relative inline-flex rounded-full size-2 bg-primary"></span>
                  </span>
                  <span className="text-xs font-semibold text-primary uppercase tracking-wide">
                    Live
                  </span>
                </div>
              </div>
              
              <div className="relative aspect-video bg-muted rounded-md overflow-hidden">
                {}
                <div id="wpstream-player-container" className="w-full h-full" role="region" aria-label="Live video stream player">
                  {isLive ? <div dangerouslySetInnerHTML={{
                  __html: '[wpstream_player id="65"]'
                }} /> : <video src="https://rackemjoelivestream.net/wp-content/uploads/2026/03/commercial2.mp4" autoPlay muted loop playsInline className="w-full h-full object-cover" />}
                </div>
              </div>

              <div className="mt-4 flex items-center justify-between text-sm text-foreground/70">
                <span>Pocket Billiards Tournament</span>
                <span className="flex items-center gap-1">
                  <span className="size-2 rounded-full bg-primary animate-pulse"></span>
                  Live Now
                </span>
              </div>
            </div>

            {}
            <div className="bg-surface rounded-lg shadow-medium p-6 lg:p-8 flex flex-col">
              <h2 className="font-display text-2xl lg:text-3xl font-bold text-foreground mb-6">
                Live Chat
              </h2>
              
              <div className="flex-1 bg-muted rounded-md overflow-hidden min-h-[400px] lg:min-h-[500px]">
                {}
                <div id="ajax-chat-container" className="w-full h-full flex flex-col p-4" role="region" aria-label="Live chat discussion">
                  <SimpleAjaxChat />
                  <Button asChild className="mt-4 w-full">
                    <Link to="/wp-login.php?action=register">
                      Register
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}